import { i18n } from '@/i18n'

export function historyPhrase(key, params) {
  return i18n.global.t(`history.${key}`, params ?? {})
}

export function historyAction(key, params) {
  return `<span class="text-muted">${historyPhrase(`actions.${key}`, params)}</span>`
}

export function historyFormatBool(value) {
  const yes = value === true || value === 'True' || value === 'true' || value === 1 || value === '1'
  return i18n.global.t(yes ? 'common.yes' : 'common.no')
}

export function historyFieldLabel(modelName, fieldKey, fallback) {
  const flat = Array.isArray(fieldKey) ? fieldKey.join('.') : String(fieldKey)
  const modelKey = `history.fields.${modelName}.${flat}`
  const commonKey = `history.fields.common.${flat}`
  if (i18n.global.te(modelKey)) return i18n.global.t(modelKey)
  if (i18n.global.te(commonKey)) return i18n.global.t(commonKey)
  return fallback
}
